export default __webpack_public_path__ + "static/media/07.2b45a66f.jpg";